import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyBGG7PdORuisG4WUmlyU9nQY3gUb-aCI9A',
  authDomain: 'emojimonsters.firebaseapp.com',
  projectId: 'emojimonsters',
  storageBucket: 'emojimonsters.appspot.com',
  messagingSenderId: '61665177046',
  appId: '1:61665177046:web:997e336239def7cf880877',
  measurementId: 'G-SYLQG4XXFD',
  databaseURL:
    'https://emojimonsters-default-rtdb.europe-west1.firebasedatabase.app',
};

const firebaseApp = initializeApp(firebaseConfig);
export const database = getDatabase(firebaseApp);
export const auth = getAuth();
export const storage = getStorage();

auth.languageCode = 'nb';
